import styled from 'styled-components';
import { space, background, color, border, layout, position, shadow, system } from 'styled-system';

import { BaseBoxProps } from './BaseBox.types';
import { space as spaceValues } from 'src/packages';

const gap = system({
  gap: {
    property: 'gap',
    scale: 'space',
    defaultScale: spaceValues,
  },
});

const BaseBox = styled.div<BaseBoxProps>(
  {
    boxSizing: 'border-box',
  },
  gap,
  background,
  space,
  color,
  border,
  layout,
  position,
  shadow
);

export default BaseBox;
